import React from 'react';
import { WhoWeAreSection } from '../components/sections/WhoWeAreSection';
import { VisionSection } from '../components/sections/VisionSection';
import { WhyChooseUsSection } from '../components/sections/WhyChooseUsSection';
import { CTABanner } from '../components/sections/CTABanner';
export function AboutPage() {
  return <>
      {/* Page Header */}
      <section className="bg-[#0B1F3A] text-white py-20" data-id="element-381">
        <div className="max-w-7xl mx-auto px-4 text-center" data-id="element-382">
          <h1 className="text-4xl lg:text-5xl font-bold mb-6" data-id="element-383">About Us</h1>
          <p className="text-xl text-gray-300 max-w-3xl mx-auto" data-id="element-384">
            Learn more about Judah Medical Transport Company and our commitment
            to excellence
          </p>
        </div>
      </section>

      <WhoWeAreSection data-id="element-385" />
      <VisionSection data-id="element-386" />
      <WhyChooseUsSection data-id="element-387" />
      <CTABanner data-id="element-388" />
    </>;
}